import moment from "moment";
import Auth from "../auth/Auth";
import {
  updateCartItems,
  updateCartLoader,
  updateEditData,
  updateViewCartData,
} from "../redux/actions/cartActions";
import store from "../redux/store";
import { http } from "./http";
import { toast } from "react-toastify";

const dispatch = store.dispatch;

export const allowNumbersWithNoSpaces = (value) => {
  return value.match(/^[0-9]*$/);
};

export const placeholderHandler = (event) => {
  return (event.target.src = "assets/img/restaurant.png");
};

export const formatPhoneNumber = (countryCode, phoneNumber) => {
  if (!countryCode || !phoneNumber) return "";
  const result = `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(
    3,
    6
  )}-${phoneNumber.substring(6, phoneNumber.length)}`;
  return `${countryCode} ${result}`;
};

export const getCartData = (bodyData) => {
  http(
    {
      method: "POST",
      url: `viewCart`,
      isSecure: true,
      body: {
        udId: Auth.userInfo()?.udId,
        order_type: "Take Out",
        donation: "no",
        tipAmount: localStorage.getItem("tipAmount") || 0,
        donationAmount: "0.10",
        order_distance: "0.0",
        addressId: 0
      },
    },
    (res) => {
      dispatch(updateCartLoader(false));
      if (res.error === "false") {
        dispatch(updateViewCartData(res));
        const oldCartItems = [];
        res?.dishes?.dishes.forEach((dishItem) => {
          const item = {
            cartId: dishItem.cartId,
            dishId: dishItem.dishId,
            quantity: dishItem.dishQuantity,
            uuId: dishItem.uuId,
            customisation: [],
            spl_instruction: dishItem.spl_instruction || "",

          };
          dishItem.dishCustomisation.forEach((dishCustomisationItem) => {
            dishCustomisationItem.customizableDishItems.forEach(
              (customizableDish) => {
                //only add those customisations which isSelected 1.
                customizableDish.isSelected &&
                  item.customisation.push({
                    dishCustomisationId: customizableDish.elementId,
                  });
              }
            );
          });
          oldCartItems.push(item);
        });
        dispatch(updateCartItems(oldCartItems));
      }
      // if (res.error === "true") {
      //   toast.error(res.errorMessage);
      //   dispatch(updateCartLoader(false));
      // }

      else if (
        res.errorMessage === "Your Cart is Empty,Add Something from the Menu"
      ) {
        dispatch(updateViewCartData({}));
        dispatch(updateCartItems([]));
      }
    },
    (res) => { }
  );
};

export const clearCart = async () => {
  dispatch(updateCartLoader(true));
  http({ method: "POST", url: "clearCart", isSecure: true }, (res) => {
    if (res.error === "false") {
      getCartData();
    }
    dispatch(updateCartLoader(false));
  });
};

// const handleFavourite = (data, index, restaurantList, setLoading) => {
//   if (!Auth.isUserAuthenticated()) {
//     dispatch(updateOnboardingState("login"));
//     return;
//   }
//   const newStatus = data.is_like ? 0 : 1;
//   setLoading(data.restaurantId);
//   http(
//     {
//       method: "POST",
//       url: `addOutletToUserFavourite`,
//       isSecure: true,
//       body: {
//         outletId: data.restaurantId,
//         status: newStatus,
//       },
//     },
//     (res) => {
//       toast.success(data.is_like ? WISHLIST.DISLIKE : WISHLIST.LIKE);
//       restaurantList.listRestaurants[index].is_like = newStatus;
//       dispatch(updateRestaurantList({ ...restaurantList }));
//       setLoading(false);
//     }
//   );
// };

export const getOutletLink = (data) => {
  const { outletId } = data;

  return `/restaurant-details/${outletId}/menu`;
};

export const getOutletLink1 = (data) => {
  const outletId = data;

  return `/restaurant-details/${outletId}/menu`;
};

export const getFilteredBill = (displayKey) => {
  return displayKey !== "Discount";
};

export const getOrdertime = (time) => {
  return time
    ? moment
      .utc(time)
      .local()
      .format("LT")
    : "00:00";
};

export const getDisplayPrice = (price) => {
  return "$" + price;
};

export const handleEditDish = (dishItem) => {
  const editData = {
    selectedItemData: {
      cartId: dishItem.cartId,
      dishId: dishItem.dishId,
      dishName: dishItem.dishName,
      description: dishItem.description,
      stock_status: dishItem.stock_status,
      isCustomisation: dishItem.isCustomisation,
      dishavailable: dishItem.dishes_availability,
      price: dishItem.dishPrice,
      dishCustomisation: dishItem.dishCustomisation,
      displayPrice: dishItem.displayPrice,
    },
    quantity: dishItem.dishQuantity,
    instructions: dishItem.spl_instruction,
  };
  dispatch(updateEditData(editData));
};

export const clearTipAdditionalInfo = () => {
  localStorage.removeItem("tipAmount");
  localStorage.removeItem("additionalInfo");
};

// export const allowNumbersWithNoSpaces = (value) => {
//   return value.match(/^[0-9]*$/);
// };


export const replaceValue = (value) => {
  let finalValue = value;

  // const isIncludingSlash = value.includes('/')

  let number = value.split("/");

  if (number[0]) {
    number[0] = number[0].slice(0, 2);

    finalValue = number[0];
    if (finalValue.length === 2) finalValue = finalValue + "/";
    // if (finalValue.length ===  ) finalValue += '/'
  }

  if (number[1]) {
    number[1] = number[1].slice(0, 4);

    finalValue = number[0] + "/" + number[1];
  }

  return finalValue;
};



